import axios, { AxiosError, AxiosRequestConfig } from 'axios'
import { BaseQueryFn } from '@reduxjs/toolkit/query'

import config from 'env'

/**
 * Default api caller based on axios
 * Use this for all standard api calls
 */

const api = axios.create({
  baseURL: config.hostname,
  timeout: config.timeout || 45000,
  withCredentials: true,
})

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response) {
      const BASE_URL = `${config.appUrl}/car-insurance-quote/quote`

      if (error.response.status === 504) {
        window.location.href = `${BASE_URL}/timeout`
      } else if (error.response.status === 410) {
        const { latestQuoteId } = error.response.data
        window.location.href = `${BASE_URL}/${latestQuoteId}/overview`
      }
    }

    return Promise.reject(error)
  },
)

/**
 * Redux baseQuery function
 * Use this for all RTK Query api services
 */

interface IAxiosBaseQuery {
  baseUrl?: string
}

const axiosBaseQuery =
  ({ baseUrl = '' }: IAxiosBaseQuery): BaseQueryFn<AxiosRequestConfig, unknown, unknown> =>
  async ({ url, method, data, params, ...rest }) => {
    try {
      const result = await api({
        url: `${baseUrl}${url}`,
        method,
        data,
        params,
        ...rest,
      })
      return { data: result.data }
    } catch (axiosError) {
      const err = axiosError as AxiosError
      return {
        error: { status: err.response?.status, data: err.response?.data },
      }
    }
  }

export { api, axiosBaseQuery }
